import React from "react";
import DetailBox from "./report/detailBox";
import Memo from "./report/memo";
import Gallery from "./gallery";
import { ReportContainer } from "../../styled/scheduler";
import { useLocation } from "react-router";

const Report = ({
  eventInfo,
  isSchedule,
  todos,
  setTodos,
  setImageOrder,
  setIsDetail,
  setActive,
  originImages,
  clickGallery,
  isUpload,
  comments = [],
}) => {
  const { pathname } = useLocation();
  return (
    <ReportContainer>
      {isSchedule && <DetailBox eventInfo={eventInfo} setActive={setActive} />}
      {isSchedule && (
        <>
          <Memo eventInfo={eventInfo} todos={todos} setTodos={setTodos} setActive={setActive} />
        </>
      )}
      {pathname.includes("share-report") &&
        (comments.length > 0 ? (
          <div className="label">
            <span>총 {comments.length}개의 댓글</span>
            <button onClick={() => setActive(3)}>더보기</button>
          </div>
        ) : (
          <div className="label">
            <span className="not">댓글이 존재하지 않습니다.</span>
          </div>
        ))}
      <Gallery
        eventInfo={eventInfo}
        setImageOrder={setImageOrder}
        setIsDetail={setIsDetail}
        isGallery={false}
        originImages={originImages}
        clickGallery={clickGallery}
        isUpload={isUpload}
      />
    </ReportContainer>
  );
};

export default Report;
